import dynamic from 'next/dynamic';

const EmbedComponent = dynamic(() => import(`./Embed`));

const components = {
    TEXT: dynamic(() => import(`./TextNoti`)),
    CITA: dynamic(() => import(`./Cites`)),
    VIDEO: dynamic(() => import(`./Video`)),
    AUDIO: dynamic(() => import(`./Audio`)),
    NOTICIA_RELACIONADA: dynamic(() => import(`./NoticiaRelacionada`)),
    LINK: dynamic(() => import(`components/3catinfo/Enllac`)),
    IMATGE: dynamic(() => import(`./ImatgeCos`)),
    IMATGE_RELACIONADA: dynamic(() => import(`./ImatgeCos`)),
    YOUTUBE: EmbedComponent,
    INSTAGRAM: EmbedComponent,
    TWITTER: EmbedComponent,
    DATAWRAPPER: EmbedComponent,
    FLOURISH: dynamic(() => import(`./Flourish`)),
    INFOGRAM: EmbedComponent,
    TIKTOK: EmbedComponent,
    CARTO: EmbedComponent,
    FACEBOOK: EmbedComponent,
    OPTA: dynamic(() => import(`./Opta`)),
    BLUESKY: EmbedComponent
};

export { components };
